<template>
  <div class="popWrap nowOpen">
    <span class="blind focusSet first" tabindex="0s"></span>
    <div class="popup">
      <div class="popContain">
        <div class="multiPopCont full" tabindex="-1" role="dialog">
          <div class="popHead">
            <h1 class="titH1">적용 가능 상품</h1>
          </div>
          <div class="multiPopBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section class="full hr mg0">
                <div class="banner">
                  <a>
                    <!-- 
                    TODO : 현재는 1안
                    1안) 적용 가능 상품은 같은 이미지
                    2안) 신규계약용, 기존계약용 다른 2개의 이미지
                    3안) 각 쿠폰마다 쿠폰에 적용된 이미지로 
                    -->
                    <span class="img">
                      <img
                        src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1604993173784_%EC%A0%81%EC%9A%A9%EA%B0%80%EB%8A%A5%EC%83%81%ED%92%88_%EC%BF%A0%ED%8F%B0%EB%B0%B0%EB%84%88.png"
                        alt=""
                      />
                    </span>
                  </a>
                </div>
              </section>
              <section class="hr mg0" v-if="categoryFlag">
                <select class="ipt" title="상담종류 선택" @change="selectChange($event)" v-model="category">
                  <option value="" disabled="disabled" selected="selected">상품 카테고리를 선택하세요.</option>
                  <option value="0">전체</option>
                  <option value="2">주방가전</option>
                  <option value="3">생활가전</option>
                  <option value="4">뷰티&amp;헬스</option>
                  <option value="5">가구</option>
                  <option value="11">디지털&amp;취미</option>
                </select>
              </section>
              <!-- 본문 (e) -->
              <section v-if="!categoryFlag">
                <ul class="prdList" v-if="products.length > 0">
                  <li v-for="(product, index) in products" :key="index">
                    <div class="block">
                      <div class="prdItem">
                        <div class="imgArea">
                          <div class="badgeArea" v-if="product.tagInfos != ''">
                            <span class="badge" v-for="(topTags, topTagsIndex) in product.tagInfos.topTags" :key="topTagsIndex">
                              <img :src="topTags.imgPath" />
                            </span>
                          </div>
                          <a class="img imgCover" @click="goDetail(product.productIndex, product.discntFlag)">
                            <img :src="product.thumbnail" :alt="product.productName" />
                          </a>
                        </div>
                        <div class="infoArea">
                          <a class="tit row2" @click="goDetail(product.productIndex, product.discntFlag)">
                            <span>{{ product.productName }}</span>
                          </a>
                          <div class="txtItem">
                            <span>{{ product.model }}</span>
                          </div>
                          <div class="hashtag" v-if="product.tagInfos != ''">
                            <span
                              v-for="(bottomTags, bottomTagsIndex) in product.tagInfos.bottomTags"
                              :key="bottomTagsIndex"
                              v-text="bottomTags.tagName"
                            ></span>
                          </div>
                          <div class="price" v-if="product.isOnepay == 'N'">
                            <span class="money del">
                              월
                              <span>{{ product.rentalAmount | currency }}</span>
                              원
                            </span>
                            <br />
                            <span class="money pointC1">
                              월
                              <em>{{ product.cardDCrentalAmount | currency }}</em>
                              원
                              <i>/제휴카드가</i>
                            </span>
                          </div>
                          <div class="price" v-if="product.isOnepay == 'Y'">
                            <span class="money pointC1">
                              <em>{{ product.saleAmount | currency }}</em>
                              원
                            </span>
                          </div>

                          <ul class="utilBtn">
                            <li>
                              <a @click="updateWishList(product)" class="icoBtn zzim" :class="{ on: product.wishItem }">
                                <span>
                                  찜 (
                                  <i>{{ product.wishCount }}</i>
                                  )
                                </span>
                              </a>
                              <!-- 클래스 on -->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <infinite-loading spinner="circles" @infinite="cponProdInfiniteHandler">
                    <div slot="no-more" v-text="noDataMsg"></div>
                    <div slot="no-results" v-text="noResultMsg"></div>
                  </infinite-loading>
                </ul>
              </section>
              <section v-if="categoryFlag">
                <ul class="prdList" v-if="products2.length > 0">
                  <li v-for="(product, index) in products2" :key="index">
                    <div class="block">
                      <div class="prdItem">
                        <div class="imgArea" @click="goDetail(product.productIndex, product.discntFlag)">
                          <div class="badgeArea" v-if="product.tagInfos != ''">
                            <span class="badge" v-for="(topTags, topTagsIndex) in product.tagInfos.topTags" :key="topTagsIndex">
                              <img :src="topTags.imgPath" />
                            </span>
                          </div>
                          <a class="img">
                            <img :src="product.thumbnail" :alt="product.productName" />
                          </a>
                        </div>
                        <div class="infoArea">
                          <a class="tit row2" @click="goDetail(product.productIndex, product.discntFlag)">
                            <span>{{ product.productName }}</span>
                          </a>
                          <div class="txtItem">
                            <span>{{ product.model }}</span>
                          </div>
                          <div class="hashtag" v-if="product.tagInfos != ''">
                            <span
                              v-for="(bottomTags, bottomTagsIndex) in product.tagInfos.bottomTags"
                              :key="bottomTagsIndex"
                              v-text="bottomTags.tagName"
                            ></span>
                          </div>
                          <div class="price" v-if="product.isOnepay == 'N'">
                            <span class="money del">
                              월
                              <span>{{ product.rentalAmount | currency }}</span>
                              원
                            </span>
                            <br />
                            <span class="money pointC1">
                              월
                              <em>{{ product.cardDCrentalAmount | currency }}</em>
                              원
                              <i>/제휴카드가</i>
                            </span>
                          </div>
                          <div class="price" v-if="product.isOnepay == 'Y'">
                            <span class="money pointC1">
                              <em>{{ product.saleAmount | currency }}</em>
                              원
                            </span>
                          </div>
                          <ul class="utilBtn">
                            <li>
                              <a @click="updateWishList(product)" class="icoBtn zzim" :class="{ on: product.wishItem }">
                                <span>
                                  찜 (
                                  <i>{{ product.wishCount }}</i>
                                  )
                                </span>
                              </a>
                              <!-- 클래스 on -->
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <infinite-loading spinner="circles" @infinite="infiniteHandler">
                    <div slot="no-more" v-text="noDataMsg"></div>
                    <div slot="no-results" v-text="noResultMsg"></div>
                  </infinite-loading>
                </ul>
              </section>
              <ConfirmPop
                v-if="confirmPop"
                @cancel="confirmPop = false"
                @confirm="$router.push({ name: 'login', params: { redirect: 'benefitsCoupon' } })"
                @close="confirmPop = false"
              >
                <p v-html="msg"></p>
              </ConfirmPop>

              <MessagePop v-if="messagePop" @close="messagePop = false">
                <p v-html="msg"></p>
              </MessagePop>
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
          <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import UpdateWishList from '@/components/comm/UpdateWishList';
import JwtService from '@/common/jwt.service';
// import * as customjs from '@/../static/js/m.front';
import InfiniteLoading from 'vue-infinite-loading';
import { LOADING_NO_DATA, LOADING_NO_RESULTS, LOGIN_REQUIRE } from '@/store/message.type.js';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'BenefitsEventDetailPop',
  components: {
    UpdateWishList,
    InfiniteLoading,
    ConfirmPop,
    MessagePop,
  },
  props: ['couponIndex'],
  mounted() {
    // customjs.init();
    this.getProductList();
  },
  data() {
    return {
      products: [],
      products2: [],
      categoryFlag: false,
      category: 0,
      page: 1,
      cponProdPage: 1,

      noDataMsg: ``,
      noResultMsg: ``,
      msg: null, // 팝업 메세지
      confirmPop: false, // 확인 팝업
      messagePop: false,
    };
  },
  methods: {
    async selectChange() {
      await ApiService.service('GET', 'product/mainMenu/' + this.category)
        .then(({ data }) => {
          if (data.isSucceed) {
            this.products2 = data.result.content;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });

      this.categoryFlag = true;
    },
    getProductList() {
      ApiService.service('GET', 'product/coupon/available/couponid/' + this.couponIndex, {
        params: { page: 1, size: 20, filter: 'rentalAmount', direction: 'ASC' },
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            this.cponProdPage++;
            if (data.result.isAllProdYn == 'N') {
              this.categoryFlag = false;
              this.products = data.result.prodList;
            } else {
              this.selectChange();
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    updateWishList(product) {
      if (!this.checkAuth()) return;
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      product.wishItem = flag;
      product.wishCount += count;
    },
    //상세 이동
    goDetail: function(idx, discntFlag) {
      if (idx != '0' && discntFlag != 'Y') {
        this.$router.push('/product/category/detail/' + idx);
      } else {
        this.msg = '단종된 상품입니다.';
        this.messagePop = true;
      }
    },
    cponProdInfiniteHandler: function($state) {
      console.log('cponProdPage ' + this.cponProdPage);

      // TODO 현재는 쿠폰적용 상품에대한 정렬 기준이 없음
      ApiService.service('GET', 'product/coupon/available/couponid/' + this.couponIndex, {
        params: { page: this.cponProdPage, size: 20, filter: 'rentalAmount', direction: 'ASC' },
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            if (data.result.isAllProdYn == 'N') {
              if (data.result.prodList.length > 0) {
                for (let product of data.result.prodList) {
                  this.products.push(product);
                }
                this.cponProdPage++;
                $state.loaded();
              } else {
                $state.complete();
              }
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    infiniteHandler: function($state) {
      console.log('page ' + this.page);

      ApiService.service('GET', '/product/mainMenu/' + this.category + '?page=' + this.page)
        .then(({ data }) => {
          if (data.isSucceed) {
            if (data.result.content.length > 0) {
              for (let content of data.result.content) {
                this.products2.push(content);
              }

              this.page++;
              $state.loaded();
            } else {
              $state.complete();
            }
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    checkAuth() {
      if (JwtService.getToken()) {
        return true;
      } else {
        // 비로그인 내가 받은 쿠폰 클릭했을때
        this.msg = LOGIN_REQUIRE;
        this.confirmPop = true;
        return false;
      }
    },
  },
};
</script>
